import React from 'react';

export default class ArticleLead extends React.Component {

  render() {
    return <p className="lead">{this.props.article.description}</p>
  }
}
